import type { LocalizedDict } from '../index'

export type SampleBulkAdoptStrings = {
  warnings: Record<
    | 'cost_missing'
    | 'cost_currency_not_usd'
    | 'supplier_missing'
    | 'color_missing'
    | 'photo_missing'
    | 'multi_axis_parent',
    string
  >
  needsValue: string
  addedToCatalog: (n: number) => string
  bulkAdoptFailed: string
  loadingWorksheet: string
  loadError: string
  samples: string
  title: string
  selectedCount: (n: number) => string
  waitingCount: (n: number) => string
  photosNote: string
  ecosystem: string
  adoptSelected: (n: number) => string
  outcome: (adopted: number, failed: number) => string
  emptyShelf: string
  include: (title: string) => string
  noFactory: string
  quote: (raw: string) => string
  listing: (price: string) => string
  sourceListing: string
  variationOfExisting: string
  newProduct: string
  parentProduct: string
  severalParents: string
  productCode: string
  productTitle: string
  axis: string
  costUsd: string
  values: (n: number) => string
  skuCodeFor: (value: string) => string
}

export const sampleBulkAdoptI18n: LocalizedDict<SampleBulkAdoptStrings> = {
  en: {
    warnings: {
      cost_missing: 'no cost',
      cost_currency_not_usd: 'cost not in USD',
      supplier_missing: 'no supplier',
      color_missing: 'no colour in brief',
      photo_missing: 'no photo',
      multi_axis_parent: 'parent has several axes',
    },
    needsValue: 'Every ticked row needs at least one variation value',
    addedToCatalog: (n) => `${n} sample(s) added to the catalog`,
    bulkAdoptFailed: 'Bulk adopt failed',
    loadingWorksheet: 'Loading the worksheet…',
    loadError: 'Could not load the worksheet.',
    samples: 'Samples',
    title: 'Add received samples to the catalog',
    selectedCount: (n) => `${n} selected sample(s).`,
    waitingCount: (n) => `${n} sample(s) waiting.`,
    photosNote: ' Photos are never carried over — upload your own from the product page after adopting.',
    ecosystem: 'Fulfillment ecosystem',
    adoptSelected: (n) => `Adopt ${n} selected`,
    outcome: (adopted, failed) => `${adopted} added · ${failed} could not be added`,
    emptyShelf: 'No received samples are waiting. Mark samples as received on the list first.',
    include: (title) => `Include ${title}`,
    noFactory: 'no factory',
    quote: (raw) => `· quote ${raw}`,
    listing: (price) => `· listing ${price}`,
    sourceListing: 'source listing',
    variationOfExisting: 'Variation of existing',
    newProduct: 'New product',
    parentProduct: 'Parent product',
    severalParents:
      'This product has several variant parents — add the variation from the product page instead.',
    productCode: 'Product code',
    productTitle: 'Product title',
    axis: 'Axis',
    costUsd: 'Cost (USD)',
    values: (n) => `Values (${n} selected)`,
    skuCodeFor: (value) => `SKU code for ${value}`,
  },
  tr: {
    warnings: {
      cost_missing: 'maliyet yok',
      cost_currency_not_usd: 'maliyet USD değil',
      supplier_missing: 'tedarikçi yok',
      color_missing: 'brifte renk yok',
      photo_missing: 'fotoğraf yok',
      multi_axis_parent: 'ana üründe birden çok eksen var',
    },
    needsValue: 'İşaretli her satırda en az bir varyasyon değeri olmalı',
    addedToCatalog: (n) => `${n} numune kataloğa eklendi`,
    bulkAdoptFailed: 'Toplu ekleme başarısız',
    loadingWorksheet: 'Çalışma sayfası yükleniyor…',
    loadError: 'Çalışma sayfası yüklenemedi.',
    samples: 'Numuneler',
    title: 'Teslim alınan numuneleri kataloğa ekle',
    selectedCount: (n) => `${n} seçili numune.`,
    waitingCount: (n) => `${n} numune bekliyor.`,
    photosNote: ' Fotoğraflar asla aktarılmaz — ekledikten sonra ürün sayfasından kendi fotoğraflarını yükle.',
    ecosystem: 'Karşılama ekosistemi',
    adoptSelected: (n) => `Seçili ${n} numuneyi ekle`,
    outcome: (adopted, failed) => `${adopted} eklendi · ${failed} eklenemedi`,
    emptyShelf: 'Bekleyen teslim alınmış numune yok. Önce listede numuneleri teslim alındı işaretle.',
    include: (title) => `${title} dahil et`,
    noFactory: 'fabrika yok',
    quote: (raw) => `· teklif ${raw}`,
    listing: (price) => `· ilan ${price}`,
    sourceListing: 'kaynak ilan',
    variationOfExisting: 'Mevcut ürünün varyasyonu',
    newProduct: 'Yeni ürün',
    parentProduct: 'Ana ürün',
    severalParents:
      'Bu ürünün birden çok varyant ana ürünü var — varyasyonu ürün sayfasından ekle.',
    productCode: 'Ürün kodu',
    productTitle: 'Ürün başlığı',
    axis: 'Eksen',
    costUsd: 'Maliyet (USD)',
    values: (n) => `Değerler (${n} seçili)`,
    skuCodeFor: (value) => `${value} için SKU kodu`,
  },
}
